<template>
    <div class="rrlb-form">
        <template v-for="item in form" :key="item.id">
            <div class="rrlbf-input">
                <label :for="item.id">{{ $t(item.label) }}</label>
                <InputText :id="item.id" v-model="item.model" />
            </div>
        </template>
    </div>
</template>
<script setup>
import InputText from 'primevue/inputtext';
import { ref } from 'vue';

const form = ref([
    {
        id: 'name',
        model: '',
        label: 'widget.name_label'
    },
    {
        id: 'email',
        model: '',
        label: 'widget.email_label'
    },
    {
        id: 'phone',
        model: '',
        label: 'widget.phone_label'
    },
    {
        id: 'note',
        model: '',
        label: 'widget.note_label'
    }
]);

</script>
<style scoped lang="scss">
.rrlb-form
{
    display: flex;
    flex-direction: column;
    gap: 12px;
    .rrlbf-input {
        display:flex;
        flex-direction: column;
        gap: 12px;
    }
}
</style>
